<template>
  <b-card class="contact-card horizontal px-0 mt-3 col-sm-7 col-xxs-12" body-class="d-flex
    contact-card-shadow p-0">
    <div class="d-flex flex-row p-0">
      <div class="d-xs-flex justify-content-center py-3 px-4 d-xxs-none" :class="configurations.classList">
        <img :src="configurations.imageUrl" width="128">
      </div>
      <div class="d-flex flex-column justify-content-around py-3 px-5">
        <strong class="d-flex text-center text-dark">
          {{ configurations.text }}
        </strong>
        <b-link class="d-flex mt-2" :class="configurations.linkClassList" :target="configurations.target" :href="href()" :to="to()">
          {{ configurations.linkText }}
        </b-link>
      </div>
    </div>
  </b-card>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  name: 'LinkCardVertical',
  props: {
    configurations: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    to () {
      if (this.configurations.linkUrl[0] === '/') { return this.configurations.linkUrl }
      return ''
    },
    href () {
      if (this.configurations.linkUrl[0] !== '/') { return this.configurations.linkUrl }
      return ''
    }
  }
})
</script>
